import Cookies from "js-cookie";
import RoleAndPermission from "./RoleAndPermission";

class liveAuth {
  static timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  static check() {
    let flag = false;
    const avUserInfo = this.getAvUserInfo()
    if (avUserInfo?.email) {
      flag = true;
    }
    return flag;
  }

  // static async checkCookie() {
  //   let res = this.cookieCondition()
  //   return res
  // }

  static getAvUserInfo() {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes' && Cookies.get('local-avuserinfo')) {
      return JSON.parse(Cookies.get('local-avuserinfo'))
    } else if (window?.avUserInfoJS) {
      const jsonObject = JSON.parse(window.avUserInfoJS);
      return jsonObject;
    }
    return false;
  }

  static getAvUserInfoString() {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
      return Cookies.get('local-avuserinfo')
    } else if (window?.avUserInfoJS) {
      return window.avUserInfoJS;
    }
    return false;
  }


  static permit(permissionKeySlug) {
    return RoleAndPermission.checkGivenPermissionOnLoadedByPermission(
      permissionKeySlug
    );
  }
}

export default liveAuth;
